// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert{width:99%;margin:auto;white-space:pre-wrap}.warning{color:red;font-size:18;font-weight:700}.spacing{margin-left:10px}.selected{font-weight:700}.text-different{color:rgba(0,221,255,.35)!important;background-color:rgba(0,221,255,.35)!important;box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}.text-different,.text-new{border:1px solid;border-color:#000}.text-new{color:rgba(0,100,255,.25)!important;background-color:rgba(0,100,255,.25)!important}", ""]);
// Exports
module.exports = exports;
